import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["loading", "show", "edit", "checkbox", "noneLabel", "editButton"]

  connect() {
    this.editing = false;
    this.fetchCalendars();
  }

  disconnect() {
    if (this.fetchXhr) {
      try { this.fetchXhr.abort(); } catch (_e) {}
      this.fetchXhr = null;
    }
  }

  fetchCalendars() {
    var controller = this;
    var url = this.element.dataset.googleCalendarBlockSettingsUrl;

    this.fetchXhr = $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (data) {
        controller.fetchXhr = null;
        controller.calendars = data.calendars;
        controller.buildShowBadges();
        controller.buildEditCheckboxes();
        controller.loadingTarget.classList.add("d-none");
        controller.showTarget.classList.remove("d-none");

        var dirtyFormEl = controller.element.closest("[data-controller*='google-dirty-form']");
        if (dirtyFormEl) {
          var dirtyForm = controller.application.getControllerForElementAndIdentifier(dirtyFormEl, "google-dirty-form");
          if (dirtyForm) dirtyForm.resetInitialState();
        }
      },
      error: function (xhr) {
        controller.fetchXhr = null;
        if (xhr.statusText === "abort") return;
        controller.loadingTarget.innerHTML = '<span class="text-danger">Unable to load calendars.</span>';
      },
    });
  }

  buildShowBadges() {
    var selectedIds = JSON.parse(this.element.dataset.googleCalendarBlockSettingsSelectedIds);
    var $show = $(this.showTarget);
    var $noneLabel = $(this.noneLabelTarget);

    this.calendars.forEach(function (cal) {
      if (selectedIds.indexOf(cal[1]) !== -1) {
        var $badge = $('<span class="badge badge-primary mr-2" style="font-size: 14px"></span>').text(cal[0]);
        $noneLabel.before($badge);
      }
    });

    if (selectedIds.length > 0 && this.element.dataset.googleCalendarBlockSettingsHasSelected === "true") {
      $noneLabel.addClass("d-none");
    }
  }

  buildEditCheckboxes() {
    var selectedIds = JSON.parse(this.element.dataset.googleCalendarBlockSettingsSelectedIds);
    var connectionId = this.element.dataset.googleCalendarBlockSettingsConnectionId;
    var $edit = $(this.editTarget);
    var $saveButton = $edit.find("button");

    this.calendars.forEach(function (cal) {
      var name = cal[0];
      var calId = cal[1];
      var checkboxId = "block-cal-" + connectionId + "-" + calId.replace(/[^a-zA-Z0-9-]/g, "-");
      var checked = selectedIds.indexOf(calId) !== -1;

      var $wrapper = $('<div class="custom-control custom-checkbox"></div>');
      var $input = $('<input class="custom-control-input" type="checkbox" />')
        .attr("name", "google_connection[block_calendar_ids][]")
        .attr("value", calId)
        .attr("id", checkboxId)
        .attr("data-target", "google-calendar-block-settings.checkbox")
        .prop("checked", checked);
      var $label = $('<label class="custom-control-label"></label>')
        .attr("for", checkboxId)
        .text(name);

      $wrapper.append($input).append($label);
      $saveButton.before($wrapper);
    });
  }

  edit() {
    this.editing = true;
    this.showTarget.classList.add("d-none");
    this.editTarget.classList.remove("d-none");

    // Hide the submit button while editing
    var dirtyFormEl = $(this.element).closest("[data-controller*='google-dirty-form']")[0];
    if (dirtyFormEl) {
      var dirtyForm = this.application.getControllerForElementAndIdentifier(dirtyFormEl, "google-dirty-form");
      if (dirtyForm) $(dirtyForm.submitButtonTarget).addClass("d-none");
    }
  }

  save() {
    this.editing = false;
    const checked = this.checkboxTargets.filter((cb) => cb.checked);
    const $show = $(this.showTarget);

    // Clear existing badges
    $show.find("span.badge-primary").remove();

    // Rebuild badges from checked checkboxes
    checked.forEach((cb) => {
      const label = this.editTarget.querySelector(`label[for="${cb.id}"]`);
      const name = label ? label.textContent.trim() : cb.value;
      const $badge = $('<span class="badge badge-primary mr-2" style="font-size: 14px"></span>').text(name);
      $(this.noneLabelTarget).before($badge);
    });

    // Toggle "No Calendars Set" visibility
    if (checked.length > 0) {
      $(this.noneLabelTarget).addClass("d-none");
    } else {
      $(this.noneLabelTarget).removeClass("d-none");
    }

    $(this.editTarget).addClass("d-none");
    $show.removeClass("d-none");

    // Trigger google-dirty-form check on the parent form
    var $form = $(this.element).closest("form");
    if ($form.length) {
      $form.trigger("change");
    }
  }

  isEditing() {
    return this.editing;
  }
}
